import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import App from './App.vue'
import router from './router'
import { checkAndRefreshToken } from './components/plugins/token'
import { updateSEO } from './utils/seo'

// 应用启动时检查 token 是否过期
checkAndRefreshToken()

// 初始化SEO
const app = createApp(App)
app.use(router).use(ElementPlus, { locale: zhCn })

// 路由加载完成后应用初始SEO
router.isReady().then(() => {
    const route = router.currentRoute.value
    if (route.meta) {
        updateSEO({
            title: route.meta.title,
            description: route.meta.description,
            keywords: route.meta.keywords
        })
    }
})

app.mount('#app')